import { useEffect } from "react";
import i18n from "@/shared/lib/i18n";
import { getToken } from "@/shared/api";
import { applyTheme, type ThemeKey } from "@/shared/hooks/useTheme";
import { profileService } from "../api/profileService";

const LOCALE_KEY = "xbgeo-locale";
let synced = false; // 每个页面生命周期只拉一次,避免每次进 AdminLayout 重复请求

/**
 * 登录后用服务端 /me/preferences 的 theme/locale 覆盖本地(跨设备一致)。
 * 失败静默降级到 localStorage(可能 401/网络抖动)。仅当有 token 时触发。
 */
export function usePreferenceSync() {
  useEffect(() => {
    if (synced || !getToken()) return;
    synced = true;
    void profileService
      .getPreferences()
      .then((pref) => {
        if (pref?.theme) applyTheme(pref.theme as ThemeKey);
        if (pref?.locale && pref.locale !== i18n.language) {
          void i18n.changeLanguage(pref.locale);
          try {
            localStorage.setItem(LOCALE_KEY, pref.locale);
          } catch {
            // ignore
          }
        }
      })
      .catch(() => {
        synced = false; // 失败允许下次重试
      });
  }, []);
}

/** 退出登录时重置,使下次登录重新拉取。 */
export function resetPreferenceSync() {
  synced = false;
}
